import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

//import Level from "../views/Level.vue";

import Units from "../views/Units.vue";
import Unit from "../views/Unit.vue";

import Login from "../views/Login.vue";

//import NotFoundView from "../views/NotFoundView.vue";


export default store => {
  Vue.use(VueRouter);

  const routes = [
 /*   {
      // not found handler
      path: '*',
      component: NotFoundView
    },*/
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/units",
      name: "Units",
      component: Units,
    }, {
      path: "/units/:id",
      name: "Unit",
      component: Unit,
      props: true,
    },
    /* {
      path: "/",
      component: Home,
      children: [
        {
          path: "/structures/:id",

          component: Structure,
          props: true,
        },
        {
          path: "/structures/:sId/levels/:id",

          component: Level,
          props: true,
        },
        {
          path: "/units",

          component: Units,
          props: true,
        },
        {
          path: "/login",

          component: Login,
          props: true,
        },
        {
          path: "/about",
          name: "about",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import("../views/About.vue"),
        },
        {
          path: "/structures",
          name: "structures",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(
              "../views/Structures.vue"
            ),
        },
      ],
    },*/
  ];

  const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
  });

  router.beforeEach((to, from, next) => {
    if (store.state.authenticated == false) {
      next();
      //next({ path: "/login" });
    } else {
      next();
    }
  });

  return router;
};
